import api from './api';

/**
 * Fetch contact messages (admin) with pagination and optional status filter.
 */
export const fetchMessages = async ({ page = 1, per_page = 15, status } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('per_page', per_page);
  if (status && status !== 'all') params.append('status', status);
  const response = await api.get(`/admin/messages?${params.toString()}`);
  return response.data;
};

/**
 * Fetch a single message (marks as read on server).
 */
export const fetchMessage = async (id) => {
  const response = await api.get(`/admin/messages/${id}`);
  return response.data;
};

/**
 * Send reply email to the message sender.
 */
export const replyToMessage = async (id, body) => {
  const response = await api.post(`/admin/messages/${id}/reply`, { body });
  return response.data;
};
